module.exports = __webpack_public_path__ + "static/media/join.260e1a80.svg";